/**
 * @file
 * Site Header script.
 */

(function themeSiteHeaderStickyScript($, Drupal, once, window, document) {
  'use strict';

  /**
   * Drupal behaviors.
   */
  Drupal.behaviors.themeSiteHeaderSticky = {
    attach() {
      if (once('themeSiteHeaderStickyDocEarlyEvents', 'html').length) {
        // Create an IntersectionObserver to toggle the 'is-pinned' class based
        // on the intersection ratio.
        const observer = new IntersectionObserver(
          ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
          { threshold: [1] },
        );

        const header = document.querySelector(".site-header__wrapper");
        if (header) {
          observer.observe(header);
        }
      }
    },
  };
}(jQuery, Drupal, once, window, document));
